import { render, staticRenderFns } from "./08.vue?vue&type=template&id=5f599fb8&scoped=true&"
import script from "./08.vue?vue&type=script&lang=js&"
export * from "./08.vue?vue&type=script&lang=js&"
import style0 from "./08.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./08.vue?vue&type=style&index=1&id=5f599fb8&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f599fb8",
  null
  
)

export default component.exports